import React from 'react';
import styled from 'styled-components';

import { Caret, ChildrenWrapperProps, Label, Popover } from 'UI-Dash-Commons-UI';
import TopDropdownMenuSectionComponent from './TopDropdownMenuSectionComponent';
import MenuSpec from "../../../types/MenuSpec";
import MenuSection from "../../../types/MenuSection";

const MenuArrow = require( '../images/menu_arrow.svg' );

interface TopDropdownMenuComponentProps
{
    menuSpec: MenuSpec | null,
    onSectionActivated: ( sectionSpec: MenuSection ) => void
}

const TopDropdownMenuComponent: React.StatelessComponent<TopDropdownMenuComponentProps> = ( {
                                                                                                menuSpec,
                                                                                                onSectionActivated
                                                                                            } ) =>
{

    // If there is no menu, just return an empty wrapper
    if ( !menuSpec || !menuSpec.menu || !menuSpec.menu.length )
    {
        return null;
    }

    const menuRoot: MenuSection = menuSpec.menu[ 0 ];

    const wrappedOnSectionActivated = ( sectionSpec: MenuSection ) =>
    {
        onSectionActivated( sectionSpec );
    };

    const headerElement = <DropdownHeader>
        <DropdownTitle
            text={menuRoot.displayName}
        />

        <DropdownImage
            src={MenuArrow}
            alt={'Show menu'}
        />

    </DropdownHeader>;

    const childElements = <DropdownChildren>
        {menuRoot.children ? menuRoot.children.map( ( sectionSpec ) => (
            <TopDropdownMenuSectionComponent
                key={sectionSpec.id}
                sectionSpec={sectionSpec}
                onSectionActivated={wrappedOnSectionActivated}
            />
        ) ) : ''}
        <DropdownCaret/>
    </DropdownChildren>;

    return <DropdownWrapper>
        <Popover
            HeaderComponent={headerElement}
            ChildrenComponent={childElements}
            ChildrenWrapper={DropdownChildrenWrapper}
            hideOnChildrenClicked={true}
        />
    </DropdownWrapper>;
};

const DropdownWrapper = styled.div`
  display: flex;
  align-items: stretch;
  flex-direction: column;

  position: relative;

  margin-top: 9px;
  margin-right: 25px;

  outline: none;
`;

const DropdownCaret = styled( Caret )`
  display: block;

  position: absolute;
  top: -7px;
  right: 4px;

  z-index: 99;
`;

const DropdownHeader = styled.div`

  padding: 8px 0 8px 9px;
  position:relative;

  cursor: pointer;

  background-color: ${props => props.theme.colors.navPrimary};
  box-shadow: 0 1px 2px 0 rgba(0,0,0,0.10);
  border-radius: 3px;
  border: ${props => `1px solid ${props.theme.colors.navPrimaryBorder}`};
`;

const DropdownImage = styled.img`
  width: 10px;
  margin-right: 6px;
  transform: rotate(90deg);

  position: relative;
  top: 2px;
`;

const DropdownTitle = styled( Label )`
  color: white;
  font-size: 11px;
  margin-right: 16px;
  
  display: inline-flex;
`;

const DropdownChildren = styled.div`
  display:  inline-flex;
  overflow: hidden;
  flex-direction: column;
  text-align: center;

  width: 260px;
  min-width: 260px;
`;

const DropdownChildrenWrapper = styled<ChildrenWrapperProps, 'div'>( 'div' )`
  position: absolute;
  top: 35px;
  right: -7px;
  z-index: 100;
  
  display: none;
  display: ${props => props.isOpen && 'inline-block'};
  outline: none;

  background-color: ${props => props.theme.colors.white};
  border-radius: 3px;

  box-shadow: 0 2px 10px rgba(90, 97, 102, 0.4);
`;

export default TopDropdownMenuComponent;
